<script setup>
import OrganisationDashboard from '@/Components/Dashboard/OrganisationDashboard'
import AdminDashboard from '@/Components/Dashboard/AdminDashboard'

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const props = defineProps({
	adminStats: {
		type: Object,
		default: null,
	},
})

</script>

<template>
	<SectionCard title="Dashboard">
		<p>Welcome to the Advance Cairns Member Portal. {{ auth.isAdmin ? 'You are logged in as admin.' : '' }}</p>
	</SectionCard>
	
	<AdminDashboard v-if="auth.isAdmin" :admin-stats="adminStats" />
	<OrganisationDashboard v-else />
</template>

